"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthereumAddress = void 0;
const ethers_1 = require("ethers");
/**
 * Represents an Ethereum address.
 */
// TODO: Make EthereumAddress extends Hex. Remember about keeping the address
//       validation while creating EthereumAddress instance.
class EthereumAddress {
    constructor(address) {
        let validAddress;
        try {
            validAddress = ethers_1.utils.getAddress(address);
        }
        catch (e) {
            throw new Error(`Invalid Ethereum address`);
        }
        this.identifierHex = validAddress.substring(2).toLowerCase();
    }
    static from(address) {
        return new EthereumAddress(address);
    }
    equals(otherValue) {
        return this.identifierHex === otherValue.identifierHex;
    }
}
exports.EthereumAddress = EthereumAddress;
//# sourceMappingURL=address.js.map